import React from "react";
import "../Components/Products.css";
import "./BestsellingProducts.css";
import StarPurple500OutlinedIcon from "@mui/icons-material/StarPurple500Outlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import image from "../assets/images/image.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom"; //Link

export default function BestsellingProducts() {
  return (
    <div className="category_outer_main bestselling_outer_main">
      <div className="container-fluid">
        <div className="row">

          <div className="col-lg-4 col-md-4 col-sm-12 col-12">
            <div className="leftalign_heading section_heading text-left">
              <h2>Best Selling Products</h2>
              <p>
                Indulge in the timeless elegance of thoughtfully crafted home
                textiles designed to elevate every corner of your living space.
              </p>
            </div>  
          </div>


          <div className="col-lg-8 col-md-8 col-sm-12 col-12">
            <div className="product_slider bestselling_product_slider">
              <Swiper
                modules={[Navigation, Autoplay]}
               
                slidesPerView={3}
                loop={true}
                autoplay={{ delay: 5000 }}
                navigation
                pagination={{ clickable: true }}

                 breakpoints={{
                320: {
                  slidesPerView: 2,
                  spaceBetween: 5,
                },
                480: {
                  slidesPerView: 2,
                  spaceBetween: 5,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
              }}
              >
                <SwiperSlide>
                  <div className="product_card">
                    <div className="product_img">
                     <Link to="/products">
                        <img src={image} alt="Carpet" />
                      </Link>
                      <div className="wishlist_icon">
                        <Link to="/products">
                          <FavoriteBorderOutlinedIcon />
                        </Link>
                      </div>
                    </div>
                    <div className="product_details">
                      <h3>
                        <Link to="/products">
                          Nazakat Hand Woven Beige Cotton Cushion Cover
                         </Link>
                      </h3>

                      <div className="stars">
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                      </div>

                      <p className="size">30x45 cm</p>

                      <div className="product_price">
                        <del>₹8,000/-</del>
                        <p className="main_price">₹4,000/-</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div className="product_card">
                    <div className="product_img">
                      <Link to="/products">
                        <img src={image} alt="Carpet" />
                      </Link>
                      <div className="wishlist_icon">
                         <Link to="/products">
                          <FavoriteBorderOutlinedIcon />
                         </Link>
                      </div>
                    </div>
                    <div className="product_details">
                      <h3>
                        <Link to="/products">
                          Nazakat Hand Woven Beige Cotton Cushion Cover
                         </Link>
                      </h3>

                      <div className="stars">
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                      </div>

                      <p className="size">30x45 cm</p>

                      <div className="product_price">
                        <del>₹8,000/-</del>
                        <p className="main_price">₹4,000/-</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div className="product_card">
                    <div className="product_img">
                       <Link to="/products">
                        <img src={image} alt="Carpet" />
                      </Link>
                      <div className="wishlist_icon">
                         <Link to="/products">
                          <FavoriteBorderOutlinedIcon />
                         </Link>
                      </div>
                    </div>
                    <div className="product_details">
                      <h3>
                        <Link to="/products">
                          Nazakat Hand Woven Beige Cotton Cushion Cover
                         </Link>
                      </h3>

                      <div className="stars">
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                      </div>

                      <p className="size">30x45 cm</p>

                      <div className="product_price">
                        <del>₹8,000/-</del>
                        <p className="main_price">₹4,000/-</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div className="product_card">
                    <div className="product_img">
                       <Link to="/products">
                        <img src={image} alt="Carpet" />
                      </Link>
                      <div className="wishlist_icon">
                         <Link to="/products">
                          <FavoriteBorderOutlinedIcon />
                        </Link>
                      </div>
                    </div>
                    <div className="product_details">
                      <h3>
                        <Link to="/products">
                          Nazakat Hand Woven Beige Cotton Cushion Cover
                        </Link>
                      </h3>

                      <div className="stars">
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                      </div>

                      <p className="size">30x45 cm</p>

                      <div className="product_price">
                        <del>₹8,000/-</del>
                        <p className="main_price">₹4,000/-</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div className="product_card">
                    <div className="product_img">
                     <Link to="/products">
                        <img src={image} alt="Carpet" />
                       </Link>
                      <div className="wishlist_icon">
                        <Link to="/products">
                          <FavoriteBorderOutlinedIcon />
                       </Link>
                      </div>
                    </div>
                    <div className="product_details">
                      <h3>
                        <Link to="/products">
                          Nazakat Hand Woven Beige Cotton Cushion Cover
                        </Link>
                      </h3>

                      <div className="stars">
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                        <StarPurple500OutlinedIcon />
                      </div>

                      <p className="size">30x45 cm</p>

                      <div className="product_price">
                        <del>₹8,000/-</del>
                        <p className="main_price">₹4,000/-</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
